// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nameimportant[data-v-89e27ddc]  #load-more-mail-messages,.namestarred[data-v-89e27ddc]  #load-more-mail-messages{margin-top:0;margin-bottom:8px}\n", ""]);
// Exports
module.exports = exports;
